<script lang="ts">
  import '@splidejs/svelte-splide/css';

  import {Splide, SplideSlide} from "@splidejs/svelte-splide";
  import type {IPromotion} from "$lib/interfaces/IPromotion";
  import {openDialog} from "$lib/stores/dialogStores";
  import {goto} from "$app/navigation";
  import {locale} from "$lib/i18n";
  import { get } from 'svelte/store';

  let splideOptions = {
    type: 'slide',
    perPage: 3,
    perMove: 1,
    gap: '1rem',
    autoplay: false,
    pagination: false,
    size: '100%',
    padding: {
      left: '0px',
      right: '24px',
    },
    arrows: false,
    pauseOnHover: true,
    breakpoints: {
      640: {
        perPage: 1,
        gap: '0.5rem',
        padding: {
          left: '0px',
          right: '0px',
        },
      },
      1024: {
        perPage: 2,
        gap: '0.5rem',
      },
      1224: {
        perPage: 3,
        gap: '1rem',
      },
    },
  };
  interface Props {
    items?: IPromotion[];
  }

  let { items = [] }: Props = $props();

  function handlePromoClick(item: IPromotion) {
    if (item.action === 'TOURNAMENT') {
      openDialog('TournamentsModal');
    } else if (item.action === 'SPORT') {
      goto(`/${get(locale)}/sports`);
    } else if (item.action === 'LINK') {
      if (item.actionValue && item.actionValue.includes('https://')) {
        window.open(item.actionValue, '_blank');
      } else {
        goto(`/${get(locale)}${item.actionValue}`);
      }
    } else {
      goto(`/${get(locale)}/promotions/${item.slug}`);
    }
  }
</script>

{#if items.length > 0}
  <div class="w-full">
    <Splide aria-label="Promotions" options="{splideOptions}">
      {#each items as item}
        <SplideSlide>
          <div
                  class="relative overflow-hidden rounded-xl cursor-pointer mx-auto w-full"
                  on:click={() => handlePromoClick(item)}
                  on:keydown={(e) => e.key === 'Enter' && handlePromoClick(item)}
                  tabindex="0"
                  role="button"
                  aria-label={item.title || 'Promotion'}
                  style="min-height: 180px; height: auto;"
          >
            <img
                    src={item.image.fileUrl || "/placeholder.svg"}
                    alt="{item.title || 'Promotion'}"
                    class="w-full h-auto max-w-full"
                    loading="lazy"
            />
          </div>
        </SplideSlide>
      {/each}
    </Splide>
  </div>
{/if}